import { Box } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import SkuPackSize from "components/Products/SkuPackSize";
import CopyableCode from "components/Shared/CopyableCode";
import { formatUpc } from "components/Shared/Forms/UpcInput";
import SkuNameCell from "components/Shared/SkuNameCell";

const fragment = gql(/* GraphQL */ `
  fragment CustomerPresenceTableSkuCell on Sku {
    id
    skuComponentsList(condition: { skuComponentType: UNIT }) {
      id
      upc
    }
    ...SkuNameCell
    ...SkuPackSize
  }
`);

type Props = {
  sku: FragmentType<typeof fragment>;
};

export default function CustomerPresenceTableSkuCell({
  sku: skuFragment,
}: Props) {
  const sku = getFragmentData(fragment, skuFragment);

  const upc = sku.skuComponentsList?.[0]?.upc;

  return (
    <>
      <SkuNameCell
        sku={sku}
        popoverProps={{ isInPortal: true, placement: "right" }}
      />

      <SkuPackSize sku={sku} fontSize=".75em" color="gray.500" mt=".25em" />

      {upc ? (
        <Box mt="-.25em">
          <CopyableCode
            code={formatUpc(upc)}
            tooltipLabel="Copy UPC"
            fontSize=".7em"
            color="gray.500"
            isTruncated
            maxW="100%"
            lineHeight="normal"
          />
        </Box>
      ) : null}
    </>
  );
}
